import { UserState } from "../../models/UserState";

const resetPasswordSuccess = (state: UserState) => {
    state.isLoading = false;
    state.isResetPassword = true;
    state.isError = null;
}

export default resetPasswordSuccess;